module.exports = __webpack_public_path__ + "img/feature_b04.a447d884.svg";